function i(t) {
  let n = 0;
  for (let e = 0; e < t.length; ++e)
    t[e] === "&" && ++n;
  return n;
}
const h = /\s*,(?![^(]*\))\s*/g, p = /\s+/g;
function a(t, n) {
  const e = [];
  return n.split(h).forEach((f) => {
    let o = i(f);
    if (o) {
      if (o === 1) {
        t.forEach((r) => {
          e.push(f.replace("&", r));
        });
        return;
      }
    } else {
      t.forEach((r) => {
        e.push(
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          (r && r + " ") + f
        );
      });
      return;
    }
    let u = [
      f
    ];
    for (; o--; ) {
      const r = [];
      u.forEach((c) => {
        t.forEach((s) => {
          r.push(c.replace("&", s));
        });
      }), u = r;
    }
    u.forEach((r) => e.push(r));
  }), e;
}
function x(t, n) {
  const e = [];
  return n.split(h).forEach((f) => {
    t.forEach((o) => {
      e.push((o && o + " ") + f);
    });
  }), e;
}
function E(t) {
  let n = [""];
  return t.forEach((e) => {
    e = e && e.trim(), // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    e && (e.includes("&") ? n = a(n, e) : n = x(n, e));
  }), n.join(", ").replace(p, " ");
}
export {
  E as parseSelectorPath
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/css-render@0.15.14/~/css-render/esm/parse.js
// module id = 1326
// module chunks = 41